import clsx from 'clsx';
import React from 'react';

import appStoreBadgeSrc from '@assets/images/app_store_badge.svg';
import googlePlayBadgeSrc from '@assets/images/google_play_badge.svg';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

const APP_STORE_URL = 'https://apps.apple.com/us/app/the-information-tech-news/id1485459932';
const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.theinformation.ticker&hl=en_GB';

interface AppStoreBadgesProps {
  className?: string;
  trackingLocation?: TrackingLocation;
}

const AppStoreBadges = ({
  className,
  trackingLocation = TrackingLocation.AppSection,
}: AppStoreBadgesProps) => {
  const { trackEvent } = useEventTracking({
    location: trackingLocation,
  });

  return (
    <div className={clsx('flex items-center gap-12', className)}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Download on the App Store"
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.AppDownloadApple }))}
      >
        <img
          src={appStoreBadgeSrc}
          loading="lazy"
          alt="Download on the App Store"
          className="h-40 w-auto"
        />
      </a>
      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Get it on Google Play"
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.AppDownloadGoogle }))}
      >
        <img
          src={googlePlayBadgeSrc}
          loading="lazy"
          alt="Get it on Google Play"
          className="h-40 w-auto"
        />
      </a>
    </div>
  );
};

export default AppStoreBadges;
